export const dailyNoteFilters = Object.freeze({
  ALL: 'all',
  ONLY_DAILY_NOTE: 'onlyDailyNote',
});
